import "./NotificationComponent.scss";

export default function NotificationComponent() {
  return <h1 className="notification">Please login to use this function</h1>;
}
